import { ISendArToIntacctInvoice } from './i-sendartointacctinvoice.interface';
import { SendToIntacctInvoice } from '../send-to-intacct/send-to-intacct-invoice.model';

export class SendArToIntacctInvoice extends SendToIntacctInvoice implements ISendArToIntacctInvoice {
	postedDate: Date = null;
	total: number;
	baseTotal: number;
	adjustmentTotal: number;
	creditTotal: number;
	debitTotal: number;
	grandTotal: number;
	ownerName: string;
	ownershipCode: string;
	payeeCode: string;
	intacctApTotal: number;
	selected: boolean;
	hasError: boolean;
	glPostingDate: Date;
	isPosted: boolean = this.postedDate? true: false;
	hasCredit: boolean;
	credit: number;
	accountingDueDate: Date;

	constructor(data: any) {
		super(data);
		this.invoiceId = data.id;
		this.id = data.id;
		this.total = !Number.isNaN(data.total)? data.total : data.baseTotal + data.adjustmentTotal;
		this.creditTotal = data.creditTotal ?? 0;
		this.debitTotal = data.debitTotal ?? 0;
		this.grandTotal = data.grandTotal ?? this.total;
		this.ownerName = data.ownerName ?? data.OwnerName ?? data.customerName ?? data.CustomerName;
		this.ownershipCode = data.ownershipCode ?? data.OwnershipCode ?? data.leaseNumber ?? data.LeaseNumber;
		this.credit = !Number.isNaN(data.TotalCredit)? data.totalCredit : 0;
		if (!this.glPostingDate) this.glPostingDate = data.invoiceProcessedDate;
		this.accountingDueDate = data.invoiceReceivedDate;
		this.postedDate = data.postedDate;
	}
}